"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.alertFragmentDependencies, fragments_1.alertFragment];
const MUTATION = `
mutation createAlert(
  $name: String!
  $sourceGroupId: String!
  $filterId: String!
  $targetGroupId: String!
  $filterOptions: String!
  $groupName: String!
) {
  createAlert(
    alertInput: {
      name: $name
      sourceGroupId: $sourceGroupId
      filterId: $filterId
      targetGroupId: $targetGroupId
      filterOptions: $filterOptions
      groupName: $groupName
    }
  ) {
    ...alertFragment
  }
}
`.trim();
const createAlertImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'createAlert');
exports.default = createAlertImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlQWxlcnRJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL211dGF0aW9ucy9jcmVhdGVBbGVydEltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FBd0U7QUFDeEUsMkVBRzRDO0FBTTVDLE1BQU0sWUFBWSxHQUFHLENBQUMsR0FBRyxxQ0FBeUIsRUFBRSx5QkFBYSxDQUFDLENBQUM7QUFFbkUsTUFBTSxRQUFRLEdBQUc7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FzQmhCLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFVCxNQUFNLGVBQWUsR0FBRyxJQUFBLGdDQUFXLEVBQ2pDLElBQUEsd0NBQW1CLEVBQUMsR0FBRyxZQUFZLEVBQUUsUUFBUSxDQUFDLEVBQzlDLGFBQWEsQ0FDZCxDQUFDO0FBRUYsa0JBQWUsZUFBZSxDQUFDIn0=